export default __webpack_public_path__ + "static/case_study_home-ca71ee9c5384661e7d26b1f9ec21a3e9.png";